import { render, staticRenderFns } from "./TipoInvestimentoForm.vue?vue&type=template&id=f6f2e13e&lang=html&"
import script from "./TipoInvestimentoForm.vue?vue&type=script&lang=js&"
export * from "./TipoInvestimentoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/spa/tipo-investimento/TipoInvestimentoForm.vue
// module id = 1532
// module chunks = 28